import React from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";

export default function SongCategoriesPicker({ formData, setFormData, name, options = [], filterFunction = () => true, inputOnly = false }) {
    const input = (
        <Typeahead
            id={`${name}-song-categories-selection`}
            options={options.filter(filterFunction)}
            labelKey={"name"}
            highlightOnlyResult
            multiple
            clearButton
            selected={formData.categories}
            placeholder="Select song categories..."
            onChange={value => setFormData({ ...formData, categories: value })}
        />
    );

    if (inputOnly) return input;

    return (
        <Form.Group as={Col} className="col-12 col-xl">
            <Form.Label>Song Categories</Form.Label>
            {input}
        </Form.Group>
    );
}
